import { render, staticRenderFns } from "./datatype.vue?vue&type=template&id=13d16687&scoped=true"
import script from "./datatype.vue?vue&type=script&lang=js"
export * from "./datatype.vue?vue&type=script&lang=js"
import style0 from "./datatype.vue?vue&type=style&index=0&id=13d16687&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d16687",
  null
  
)

export default component.exports